import React, { ReactNode } from "react";

import { LocationProvider } from "@adsk/acc-locations-components";
import { useCurrentProjectId } from "@adsk/alloy-provider";

import { FeatureFlagProvider } from "../../providers/FeatureFlagProvider";
import { SearchContextProvider } from "../shared/SearchContext";

const AssetsProvider: React.FC<{ children?: ReactNode }> = ({ children }) => (
  <FeatureFlagProvider>
    <LocationProvider projectId={useCurrentProjectId()}>
      <SearchContextProvider>{children}</SearchContextProvider>
    </LocationProvider>
  </FeatureFlagProvider>
);

export default AssetsProvider;
